<template>
  <v-toolbar color="primary" dark fixed app clipped-left>
    <v-toolbar-side-icon @click.stop="$emit('toolbarSideIconClick')"></v-toolbar-side-icon>
    <v-toolbar-title><router-link to="/home"><img src="@/assets/Logo_Full_White_Trans.png" style="height:48px;padding-top:8px;"/></router-link></v-toolbar-title>
    <v-spacer/>
    <v-toolbar-title></v-toolbar-title>
    <v-spacer/>
    <v-toolbar-items>
      <v-menu offset-y bottom left origin="top right">
        <v-btn slot="activator" flat>{{ currentUser.username }}
          <v-avatar size="32px" style="margin-left: 12px" color="secondary"><span class="white--text">{{ currentUser.avatarFirstLetter }}</span></v-avatar>
        </v-btn>
        <v-list>
          <v-list-tile :to="{ path: '/account' }">
            <v-list-tile-title>Account</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{ path: '/logout' }">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Toolbar',
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  }
}
</script>
